import SectionHeading from '@/pages/home/components/SectionHeading';
import { permanentMethods } from '@/mocks/home';

export default function PermanentEntry() {
  return (
    <section id="permanent" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="永久入口"
          title="把发布页当作长期的起点"
          desc="永久入口的意义在于“不随单次变动失效”。与其记住每一串地址，不如固定一个记录入口信息的地方，再从这里出发查找其它入口。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {permanentMethods.map((m) => (
              <article key={m.title} className="rounded-lg bg-background-50 border border-background-200/70 p-5 h-full">
                <div className="flex items-center justify-between">
                  <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                    <i className={`${m.icon} text-xl`}></i>
                  </div>
                  <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium whitespace-nowrap">
                    {m.label}
                  </span>
                </div>
                <h3 className="mt-4 text-base font-semibold text-foreground-950">{m.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{m.desc}</p>
              </article>
            ))}
          </div>

          <div className="rounded-lg overflow-hidden border border-background-200/70 bg-background-50">
            <div className="relative w-full aspect-[16/10]">
              <img
                src="https://readdy.ai/api/search-image?query=minimalist%20constellation%20map%20on%20warm%20cream%20paper%20texture%2C%20golden%20connected%20dots%20forming%20an%20elegant%20star%20pattern%2C%20editorial%20illustration%2C%20soft%20warm%20neutral%20tones&width=1200&height=800&seq=starcinema-banner-01&orientation=landscape"
                alt="星座连线图，象征长期固定的入口记录"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-6 md:p-7">
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950">为什么固定起点更可靠</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                入口地址会随网络环境调整而变化，如果每次都依赖记忆中的某一串地址，很容易用到已经过期的版本。固定一个长期存在的记录入口，就等于把“找入口”这件事变成了“查记录”，判断会简单得多。
              </p>
              <ul className="mt-5 flex flex-col gap-3">
                {[
                  '记录包含分类与更新时间，便于比对',
                  '同一入口多次出现时，以更新的记录为准',
                  '更换设备后依然能通过收藏快速找回',
                ].map((t) => (
                  <li key={t} className="flex items-start gap-2.5 text-sm text-foreground-700">
                    <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 shrink-0 mt-0.5">
                      <i className="ri-check-line text-xs"></i>
                    </span>
                    {t}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}